import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "production/type-status"

class service {

    getStatusFinishSuccess() {
        return http.get(path + "/statusFinishSuccess").then(response => {
            return response.data
        });
    }

    getStatusFinishError() {

        let params = new URLSearchParams()
        params.append("typeOperation","3")

        return this.selectList(params)
    }

    getCommon() {

        let params = new URLSearchParams()
        params.append("typeOperation","1")

        return this.selectList(params)
    }

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

}

export default new service();


